import Image from 'next/image'
import NextLink from 'next/link'
import clsx from 'clsx'

import type { ButtonProps } from '@wartek-id/button-v1'
import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import PelaksanaanStatusBadge from 'app/KinerjaPenilikPegawaiPage/components/PelaksanaanStatusBadge'

import type { StatusPelaksanaanUnion } from 'types/kinerja-penilik-pegawai'

interface PelaksanaanCardLinkProps
  extends React.HTMLAttributes<HTMLDivElement> {
  href: string
}
const PelaksanaanCardLink = ({ href, children }: PelaksanaanCardLinkProps) => {
  if (Boolean(href)) {
    return (
      <NextLink href={href} passHref>
        {children}
      </NextLink>
    )
  }

  return <>{children}</>
}

interface PelaksanaanCardProps extends React.HTMLAttributes<HTMLDivElement> {
  imageSrc: string
  title: string
  state: StatusPelaksanaanUnion
  href?: string
  isAppealInProgress?: boolean
  onCtaClick?: () => void
}

const BUTTON_STATES: Record<
  StatusPelaksanaanUnion,
  { text: string; color: ButtonProps['color'] }
> = {
  // Praktik Kinerja
  DISKUSI_PERSIAPAN: { text: 'Lakukan', color: 'blue' },
  PENDAMPINGAN_SEKOLAH: { text: 'Lakukan', color: 'blue' },
  DISKUSI_TINDAK_LANJUT: { text: 'Lakukan', color: 'blue' },
  DISKUSI_TINDAK_LANJUT_PENILAIAN: { text: 'Lakukan', color: 'blue' },
  UPAYA_TINDAK_LANJUT: { text: 'Lakukan', color: 'blue' },
  REFLEKSI_TINDAK_LANJUT: { text: 'Lakukan', color: 'blue' },
  REFLEKSI_TINDAK_LANJUT_PENILAIAN: { text: 'Lakukan', color: 'blue' },

  // Perilaku Kerja
  MULAI_LAKSANAKAN: { text: 'Lakukan', color: 'blue' },
  SUDAH_DINILAI: { text: 'Cek', color: 'white' },

  // Pengembangan Kompetensi
  MULAI_REFLEKSI: { text: 'Lakukan', color: 'blue' },
  SUDAH_REFLEKSI: { text: 'Cek', color: 'white' },

  // Pelaksanaan Tugas
  CENTANG_KETERSEDIAAN_DOKUMEN: { text: 'Lakukan', color: 'blue' },
  DOKUMEN_TERSEDIA: { text: 'Cek', color: 'white' },
  DOKUMEN_TERSEDIA_TK: { text: 'Cek', color: 'white' },

  // General
  SELESAI: { text: 'Cek', color: 'white' },
}

export default function PelaksanaanCard({
  imageSrc,
  title,
  state,
  href,
  onCtaClick = () => {},
  isAppealInProgress,
  className,
  ...props
}: PelaksanaanCardProps) {
  let buttonProps = BUTTON_STATES[state]

  if (!buttonProps || isAppealInProgress) {
    // This statement should be unreachable.
    // If it's reached, it means there's a new state that's not handled.

    console.error(`Invalid pelaksanaan state: ${state}`)

    buttonProps = { text: 'Cek', color: 'white' }
  }

  return (
    <div
      className={clsx(
        'p-6 flex gap-6 border-b last:border-b-0 border-b-subdued',
        className
      )}
      {...props}
    >
      <Image src={imageSrc} width={64} height={64} alt="" />
      <div className="flex justify-between flex-1 gap-1">
        <div className="flex flex-col gap-3">
          <Text variant="heading-sm">{title}</Text>
          <PelaksanaanStatusBadge
            state={state}
            isAppealInProgress={isAppealInProgress}
          />
        </div>

        <div className="ml-auto">
          <PelaksanaanCardLink href={href}>
            <Button
              size="lg"
              color={buttonProps.color}
              onClick={onCtaClick}
              className="w-32"
            >
              {buttonProps.text}
            </Button>
          </PelaksanaanCardLink>
        </div>
      </div>
    </div>
  )
}
